import React, { useEffect } from 'react';
import {
  FaReact,
  FaNodeJs,
  FaJs,
  FaHtml5,
  FaCss3,
  FaGitAlt,
} from 'react-icons/fa';
import { SiTypescript, SiGatsby, SiStyledComponents } from 'react-icons/si';
import Aos from 'aos';
import 'aos/dist/aos.css';

import { Container, Left, Image, Me, Carousel, Undraw } from './styles';

import undrawImage from '../../assets/undraw01.svg';

export default function About() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      <Container id='about' data-aos='fade-right'>
        <Left>
          <Image
            src='https://avatars.githubusercontent.com/u/38335770?v=4'
            alt='Profile'
          ></Image>

          <Me>
            <p>
              Hello, my name is Caio. I have a Bachelor's degree in Computer
              Science from the Euripides University Center of Marilia (
              <a
                className='underlined-a'
                href='https://www.univem.edu.br/home'
                target='_blank'
                rel='noopener noreferrer'
              >
                UNIVEM
              </a>
              ).
            </p>
            <p>I am currently a developer of JavaScript based technologies.</p>

            <ul>
              <li>HTML</li>
              <li>CSS (Styled Components, Sass)</li>
              <li>JavaScript (ES6+)</li>
              <li>TypeScript</li>
              <li>Node.js</li>
              <li>React (Gatsby, Next.js)</li>
              <li>React Native</li>
              <li>Git &#38; GitHub</li>
            </ul>

            <Carousel>
              <figure>
                <FaHtml5 size='40px' color='#f15931' />
              </figure>
              <figure>
                <FaCss3 size='40px' color='#007dc6' />
              </figure>
              <figure>
                <FaJs size='40px' color='#e5a228' />
              </figure>
              <figure>
                <SiTypescript size='40px' color='#2F74C0' />
              </figure>
              <figure>
                <FaNodeJs size='40px' color='#689f63' />
              </figure>
              <figure>
                <FaReact size='40px' color='#61dafb' />
              </figure>
              <figure>
                <FaGitAlt size='40px' color='#F54D27' />
              </figure>
              <figure>
                <SiGatsby size='40px' color='#663399' />
              </figure>
              <figure>
                <SiStyledComponents size='40px' color='#C770AC' />
              </figure>
            </Carousel>

            <p>
              Visit my{' '}
              <a
                className='underlined-a'
                href='https://br.linkedin.com/in/caio-mantovani-borba'
                target='_blank'
                rel='noopener noreferrer'
              >
                LinkedIn
              </a>{' '}
              profile or{' '}
              <a
                className='underlined-a'
                href='https://github.com/CaioMantovaniBorba'
                target='_blank'
                rel='noopener noreferrer'
              >
                GitHub
              </a>{' '}
              repository for more details.
            </p>
          </Me>
        </Left>

        <Undraw src={undrawImage} alt='Undraw' />
      </Container>
    </>
  );
}
